import { darken, lighten } from '@mui/material/styles';

export const TRAINING_USER_COLORS = {
  1: '#FFD54F', // yellow
  2: '#FFA726', // orange
  3: '#9C27B0', // purple
  4: '#26C6DA', // cyan
};

export const getTrainingColor = (ordinal = 1) => {
  return TRAINING_USER_COLORS[ordinal] || TRAINING_USER_COLORS[1];
};

const getBackgroundColor = (color, theme, coefficient) => ({
  backgroundColor: darken(color, coefficient),
  ...theme.applyStyles('light', {
    backgroundColor: lighten(color, coefficient),
  }),
});

export const createCaseReviewGridStyles = (theme) => ({
  height: '100%',
  width: '100%',
  minHeight: 0,
  '& .MuiDataGrid-main': {
    flex: 1,
    minHeight: 0,
  },
  '& .MuiDataGrid-virtualScroller': {
    overflow: 'auto',
  },
  boxShadow: 2,
  '& .MuiDataGrid-cell:hover': {
    color: 'primary.main',
  },
  '& .case-review--positive': {
    ...getBackgroundColor('#66bb6a', theme, 0.2),
    '&:hover': {
      ...getBackgroundColor('#66bb6a', theme, 0.4),
    },
    '&.Mui-selected': {
      ...getBackgroundColor('#66bb6a', theme, 0),
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        ...getBackgroundColor('#66bb6a', theme, 0.3),
      },
    },
  },
  '& .case-review--weak-negative': {
    ...getBackgroundColor('#f44336', theme, 0.75),
    '&:hover': {
      ...getBackgroundColor('#f44336', theme, 0.8),
    },
    '&.Mui-selected': {
      ...getBackgroundColor('#f44336', theme, 0.6),
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        ...getBackgroundColor('#f44336', theme, 0.7),
      },
    },
  },
  '& .case-review--negative': {
    ...getBackgroundColor('#f44336', theme, 0.5),
    '&:hover': {
      ...getBackgroundColor('#f44336', theme, 0.6),
    },
    '&.Mui-selected': {
      ...getBackgroundColor('#f44336', theme, 0.3),
      border: `1px solid ${theme.palette.primary.main}`,
      '&:hover': {
        ...getBackgroundColor('#f44336', theme, 0.4),
      },
    },
  },
  '& .MuiDataGrid-cell': {
    border: 'none !important',
    borderTop: 'none !important',
    boxSizing: 'border-box',
    '&.Mui-selected': {
      borderLeft: `2px solid ${theme.palette.primary.main}`,
      borderRight: `2px solid ${theme.palette.primary.main}`,
      borderBottom: 'none',
      backgroundColor: lighten('#66bb6a', 0.1),
    },
    '&.photo-cell-no-padding': {
      padding: '0 !important',
      margin: '0 !important',
    },
  },
  '& .edited': {
    color: '#facc15',
  },
  '& .test-border': {
    border: '1px solid black !important',
    '&:hover': {
      border: '1px solid black !important',
    },
  },
  '& .error-border': {
    border: '2px solid #ff0000 !important',
    '&:hover': {
      border: '2px solid #ff0000 !important',
    },
  },
  // Training comps styling (row+cells for full-width color and yellow/orange/purple/cyan borders)
  '& .MuiDataGrid-row.training-comp .MuiDataGrid-cell': {
    borderTop: '2px solid #FFD54F !important',
    borderBottom: '2px solid #FFD54F !important',
  },
  '& .MuiDataGrid-row.training-comp .MuiDataGrid-cell:first-of-type': {
    borderLeft: '2px solid #FFD54F !important',
  },
  '& .MuiDataGrid-row.training-comp .MuiDataGrid-cell:last-of-type': {
    borderRight: '2px solid #FFD54F !important',
  },
  '& .MuiDataGrid-row.training-comp': {
    boxShadow: 'inset 0 0 0 2px #FFD54F',
  },
  // Per-user ordinal variants (1: yellow, 2: orange, 3: purple, 4+: cyan)
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-1 .MuiDataGrid-cell': {
    borderColor: '#FFD54F !important',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-1': {
    boxShadow: 'inset 0 0 0 2px #FFD54F',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-2 .MuiDataGrid-cell': {
    borderColor: '#FFA726 !important',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-2': {
    boxShadow: 'inset 0 0 0 2px #FFA726',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-3 .MuiDataGrid-cell': {
    borderColor: '#9C27B0 !important',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-3': {
    boxShadow: 'inset 0 0 0 2px #9C27B0',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-4 .MuiDataGrid-cell': {
    borderColor: '#26C6DA !important',
  },
  '& .MuiDataGrid-row.training-comp.training-user-ordinal-4': {
    boxShadow: 'inset 0 0 0 2px #26C6DA',
  },
});


